var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 56,
    viewBox: "0 0 142 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    fill: "url(#paint0_linear_2361_1609)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    stroke: "#8CBEE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 130,
    height: 44,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2355 10.7832C38.7486 10.7832 46.4711 18.5056 46.4711 28.0187C46.4711 37.5319 38.7486 45.2543 29.2355 45.2543C19.7224 45.2543 12 37.5319 12 28.0187C12 18.5056 19.7224 10.7832 29.2355 10.7832Z",
    fill: "url(#paint1_linear_2361_1609)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3274 16.5654C24.6467 15.8566 33.7868 15.8193 42.1434 16.5654C38.9723 12.984 34.3837 10.7456 29.2354 10.7456C24.0871 10.7829 19.4984 13.0213 16.3274 16.5654Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2929 39.2476C34.1974 39.8818 24.5723 39.9191 16.1411 39.2476C19.3122 42.9409 23.9754 45.2539 29.2356 45.2539C34.4585 45.2539 39.1591 42.9409 42.2929 39.2476Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5596 23.6537C23.7888 23.4672 34.7196 23.4299 45.9115 23.6537C46.2845 25.0714 46.4711 26.5263 46.4711 28.0186C46.4711 29.3243 46.3218 30.63 46.0607 31.8238C34.7196 32.1596 23.5277 32.085 12.4104 31.8238C12.1492 30.5927 12 29.3243 12 28.0186C12 26.489 12.1865 25.0341 12.5596 23.6537Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3969 24.5303C79.8228 24.5303 78.3679 26.0225 77.9948 28.9697L77.6963 32.0289C77.5844 33.2973 76.9875 34.0061 75.8683 34.1553C75.5699 34.1553 75.4207 34.3045 75.4207 34.603V35.8341C75.4207 36.0952 75.5699 36.2445 75.8683 36.2445C78.3306 36.2445 79.6736 34.7895 79.972 31.9169L80.2705 29.2309C80.3451 28.2236 80.5316 27.5894 80.7928 27.2909C81.0912 26.9179 81.6881 26.7314 82.5089 26.7314H84.4488V35.7222C84.4488 35.9833 84.5607 36.1325 84.8592 36.1325H86.2768C86.5379 36.1325 86.6872 35.9833 86.6872 35.7222V24.978C86.6872 24.6795 86.5379 24.5303 86.2768 24.5303H82.3969Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5046 31.2456V24.9781C66.5046 24.6797 66.3554 24.5305 66.057 24.5305H64.602C64.3409 24.5305 64.1917 24.6797 64.1917 24.9781V31.9917C64.1917 34.8643 65.572 36.3193 68.2953 36.3193C69.6384 36.3193 70.8695 35.8343 72.0633 34.8643L72.3244 35.8716C72.4364 36.0581 72.5856 36.0954 72.6975 36.0954H73.7048C74.0032 36.0954 74.1524 35.9835 74.1524 35.7224V24.9408C74.1524 24.6424 73.9659 24.4932 73.6675 24.4932H72.2871C71.9887 24.4932 71.8394 24.6424 71.8394 24.9408V32.4767C70.9814 33.484 69.8995 34.0063 68.6684 34.0063C67.2135 34.0436 66.5046 33.0736 66.5046 31.2456Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4754 30.8721C62.4754 27.2907 60.5355 25.5 56.6183 25.5H53.7084V21.9559H60.4609C60.7593 21.9559 60.8712 21.7693 60.9085 21.4709V20.1652C60.8712 19.8294 60.7593 19.6802 60.4609 19.6802H51.7685C51.47 19.6802 51.3208 19.8667 51.3208 20.1652V31.2078C51.3208 34.4908 52.8877 36.1323 55.9841 36.1323H56.3945C60.4235 36.1696 62.4754 34.4162 62.4754 30.8721ZM56.6929 27.701C58.9313 27.701 60.0505 28.7829 60.0505 30.9094C60.0505 32.9612 58.9313 34.0058 56.6929 34.0431H55.9468C54.4545 34.0058 53.6711 33.1851 53.6711 31.5436V27.7383H56.6929V27.701Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.524 29.1565H115.226V24.9408C115.226 24.6424 115.077 24.4932 114.779 24.4932H113.361C113.1 24.4932 112.988 24.6424 112.988 24.9408V35.6851C112.951 35.9462 113.1 36.0954 113.361 36.0954H114.779C115.077 36.0954 115.226 35.9462 115.226 35.6851V31.2456H120.524V35.6851C120.524 35.9462 120.711 36.0954 120.972 36.0954H122.352C122.65 36.0954 122.8 35.9462 122.8 35.6851V24.9408C122.8 24.6424 122.65 24.4932 122.352 24.4932H120.972C120.673 24.4932 120.524 24.6424 120.524 24.9408V29.1565Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.892 24.5303H108.474C108.138 24.5303 107.989 24.6795 107.989 24.978V32.5138C107.131 33.5211 106.087 34.0434 104.818 34.0434C103.4 34.0434 102.692 33.1107 102.692 31.2454V24.978C102.692 24.6795 102.542 24.5303 102.281 24.5303H100.864C100.528 24.5303 100.379 24.6795 100.379 24.978V31.9915C100.379 34.8641 101.759 36.3191 104.482 36.3191C105.937 36.3191 107.206 35.8341 108.288 34.8641L108.511 35.8714C108.623 36.0579 108.735 36.0952 108.885 36.0952H109.892C110.153 36.0952 110.302 35.9833 110.302 35.7222V24.9406C110.302 24.6795 110.153 24.5303 109.892 24.5303Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.265 20.2028C110.265 19.867 110.116 19.7178 109.817 19.7178H100.864C100.528 19.7178 100.379 19.9043 100.379 20.2028V21.5085C100.379 21.8069 100.565 21.9935 100.864 21.9935H109.817C110.116 21.9935 110.265 21.8069 110.265 21.5085V20.2028Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3424 26.7315C95.5662 27.0299 95.6781 27.5149 95.6781 28.1864V28.4476L93.1413 28.5595C90.2687 28.746 88.8511 30.0144 88.8511 32.402C88.8511 34.9762 90.306 36.2819 93.2159 36.2819C94.2605 36.2819 95.2678 36.0207 96.2004 35.4238L96.387 35.8342C96.5735 36.0207 96.6854 36.0581 96.7973 36.0581H97.6927C97.9165 36.0581 98.0284 35.9461 98.0284 35.685V28.1118C98.0284 25.4257 96.5362 24.0454 93.5144 24.0454C92.2086 24.0454 91.0521 24.2319 90.0449 24.6423C89.8583 24.7915 89.7837 24.9408 89.7837 25.0527V26.3584C89.821 26.5449 89.8957 26.6569 89.9703 26.7315C90.1568 26.7688 90.2687 26.7688 90.3433 26.7688C91.276 26.3957 92.3579 26.2465 93.5144 26.2465C94.3724 26.2838 95.0066 26.433 95.3424 26.7315ZM93.2159 34.1554C91.9102 34.1554 91.276 33.5585 91.276 32.402C91.2387 31.2455 91.8729 30.6486 93.104 30.5367L95.6408 30.2756L95.6781 33.4093C94.8201 33.9316 93.9993 34.1554 93.2159 34.1554Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 24.6049L129.925 24.5303H129.44L128.731 26.2091L127.985 24.5303H127.5V27.2163H127.911V25.3137L128.545 26.8433H128.881L129.589 25.3137L129.515 27.1417L129.589 27.2163H129.925L130 27.1417V24.6049Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.127 24.6049L127.053 24.5303H125.299V24.978H125.971V27.1417L126.045 27.2163H126.381V24.978H127.053L127.127 24.9033V24.6049Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2361_1609",
    x1: 73.4244,
    y1: 56,
    x2: 73.335,
    y2: -0.00372781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060B7",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2361_1609",
    x1: 11.9834,
    y1: 28.0194,
    x2: 46.4807,
    y2: 28.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FBB034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFC233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#FFDD2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFF32A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#FFE42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8871,
    stopColor: "#F2C837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B13B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeline);
export default __webpack_public_path__ + "static/media/beeline.25eaa0ec87d984eaf1d3548a96b3fa53.svg";
export { ForwardRef as ReactComponent };